module.exports = __webpack_public_path__ + "static/media/logo-horizontal-blue.93c89f37.png";